const getCapacityOptions = (filters, t) => {
    const caps = [];
    caps.push({ label: t("searchBar.persPlaceholder"), value: null }); // Reset option

    if (filters?.usages?.includes("conference_room")) {
      caps.push({ label: "100-200", value: "100-200" });
      caps.push({ label: "200-500", value: "200-500" });
      caps.push({ label: "500+", value: "500+" });
    } else {
      for (let i = 1; i <= 100; i++) {
        caps.push({ label: i === 100 ? "100+" : `${i}`, value: i === 100 ? "100+" : i });
      }
    }

    return caps;
  };

  export default getCapacityOptions;